import { CardItem } from 'src/app/components/Elements/Card';
import { CardRowText } from 'src/app/components/Elements/Card/CardRowText';
import { Skeleton } from 'src/app/components/Elements/Skeleton';
import { RefrigerationItem } from 'src/app/components/Pages/Order/Tracking/Elements';
import { OrderPriceBreakdown } from 'src/app/components/PageSections/OrderPriceBreakdown';
import type { OrderItem } from 'src/app/types';
import { formatPrice } from 'src/app/utils';

interface CardOrderSummaryItemProps {
  orderItems: OrderItem[];
  subtotal: number;
  total: number;
  tax: number;
  tip: number;
}

export const CardOrderSummaryItem = ({ orderItems, subtotal, tip, total, tax }: CardOrderSummaryItemProps) => {
  // Display a loading spinner while order details for the order are still fetching
  // eslint-disable-next-line
  if (subtotal == undefined || !orderItems.length) return <Skeleton spinnerSize={50} />;
  const showOrderPriceBreakdown = (typeof tip === 'number' && tip > 0) || tax > 0;

  return (
    <>
      {orderItems.map((orderItem, index) => {
        const { name, dosage, isRefrigerationRequired, priceInDollars, formattedQuantity } = orderItem;
        const nameDosageAndQuantity = `${name} ${dosage ?? ''} ${formattedQuantity ?? ''}`;

        return (
          <CardItem key={`orderItem_${index}`}>
            <CardRowText
              leftText={nameDosageAndQuantity}
              rightText={formatPrice(priceInDollars)}
              leftTextVariant={'body'}
              rightTextVariant={'body'}
              data_cy={`order-item-name-${index}`}
            />
            {isRefrigerationRequired && <RefrigerationItem />}
          </CardItem>
        );
      })}
      {showOrderPriceBreakdown && <OrderPriceBreakdown tip={tip} subtotal={subtotal} tax={tax} />}
      <CardItem>
        <CardRowText
          data_cy={'order-total'}
          leftText={'Total'}
          rightText={formatPrice(total)}
          leftTextVariant={'bodyBold'}
          rightTextVariant={'bodyBold'}
        />
      </CardItem>
    </>
  );
};
